import {
  AnonymousAvatar,
  Avatar,
  AvatarIcon,
  AvatarProps,
  ProgressContainer,
  Reaction,
  renderReaction,
} from '.';

export interface ProgressAvatarProps extends Omit<AvatarProps, 'shape'> {
  percentage: number;
  reaction?: Reaction;
  icon?: AvatarIcon;
}

export const ProgressAvatar: React.FC<ProgressAvatarProps> = ({
  percentage,
  reaction,
  icon,
  size,
  children,
  ...props
}) => {
  return (
    <ProgressContainer percentage={percentage} innerPadding={4} size={size}>
      <div className='relative'>
        {icon ? (
          <AnonymousAvatar icon={icon} size={size} {...props} />
        ) : (
          <Avatar size={size} {...props}>
            {children}
          </Avatar>
        )}
        {reaction && renderReaction(reaction)}
      </div>
    </ProgressContainer>
  );
};
